import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { primaryNavigation, secondaryNavigation } from "../../app/navigation.js";
import { NotificationsCount } from "../../features/notifications/NotificationsCount.jsx";
import { AxonIcon } from "../../icons/AxonIcon.jsx";

const coreItems = primaryNavigation.slice(0, 3);
const moreItems = [...primaryNavigation.slice(3), ...secondaryNavigation];

export function MobileNav() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const moreButtonRef = useRef(null);

  useEffect(() => setIsOpen(false), [location.pathname]);

  function closePanel() {
    setIsOpen(false);
    requestAnimationFrame(() => moreButtonRef.current?.focus());
  }

  return (
    <>
      {isOpen ? <button className="mobile-nav__scrim" aria-label="Закрыть меню" onClick={closePanel} /> : null}
      <nav className="mobile-nav" aria-label="Мобильная навигация">
        {coreItems.map((item) => (
          <NavLink
            key={item.path}
            className={({ isActive }) => `mobile-nav__link${isActive ? " is-active" : ""}`}
            to={item.path}
            end={item.path === "/"}
          >
            {({ isActive }) => (
              <>
                <AxonIcon name={item.icon} size={21} active={isActive} />
                <span>{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
        <button
          ref={moreButtonRef}
          className={`mobile-nav__link${isOpen ? " is-open" : ""}`}
          type="button"
          aria-expanded={isOpen}
          aria-controls="mobile-more-menu"
          onClick={() => setIsOpen((value) => !value)}
        >
          <AxonIcon name="more" size={21} active={isOpen} />
          <span>Ещё</span>
        </button>
      </nav>
      {isOpen ? (
        <section id="mobile-more-menu" className="mobile-more" aria-label="Остальные разделы">
          <div className="mobile-more__head">
            <p className="type-meta">Все разделы</p>
            <button type="button" onClick={closePanel}>
              Закрыть
            </button>
          </div>
          <ol>
            {moreItems.map((item) => (
              <li key={item.path}>
                <NavLink to={item.path}>
                  <span className="type-meta">{item.index}</span>
                  <span>{item.label}</span>
                  {item.path === "/notifications" ? <NotificationsCount /> : null}
                  <span aria-hidden="true">↗</span>
                </NavLink>
              </li>
            ))}
          </ol>
        </section>
      ) : null}
    </>
  );
}
